export default __webpack_public_path__ + "static/media/img3.e908a366.png";